<template>
  <Header_en></Header_en>
  <Concept_index_en></Concept_index_en>
  <Concept_page_en></Concept_page_en>
  <a-row style="height: 5vh"/>
  <Footer_en></Footer_en>
</template>

<script>
import Header_en from "@/components/EN/Header_en";
import Concept_index_en from "@/components/EN/concept/Concept_index_en";
import Concept_page_en from "@/components/EN/concept/Concept_page_en";
import Footer_en from "@/components/EN/Footer_en";

export default {
  name: 'Concept_en',
  components: {Concept_page_en, Concept_index_en, Footer_en, Header_en},
}

</script>